module.exports = __webpack_public_path__ + "/login_ui/img/fi-ace59fb9ca3e3059799182b832ec313e.svg";